import {
    initializeConversationReadingPaneInSxS,
    initializeItemReadingPaneInSxS,
    initializeReadingPaneInSxS,
    initializeReadingPaneInSxSByCopyingMailReadingPane,
} from '../actions/internalActions';
import { SxSReadingPaneInitializeMethod } from '../types/SxSReadingPaneStrategy';
import { lazyOnSxSReadingPaneChange } from 'owa-sxs-store';
import { orchestrator } from 'satcheljs';

orchestrator(initializeReadingPaneInSxS, async actionMessage => {
    const {
        readingPaneStrategy,
        previewPaneSelectionSource,
        parentItemId,
        instrumentationContext,
    } = actionMessage;
    if (!readingPaneStrategy) {
        return;
    }

    switch (readingPaneStrategy.method) {
        case SxSReadingPaneInitializeMethod.NoOp:
            return;
        case SxSReadingPaneInitializeMethod.AlwaysHidden:
            const onSxSReadingPaneChange = await lazyOnSxSReadingPaneChange.import();
            onSxSReadingPaneChange(null);
            return;
        case SxSReadingPaneInitializeMethod.CopyMailReadingPaneContainer:
            initializeReadingPaneInSxSByCopyingMailReadingPane(
                previewPaneSelectionSource,
                parentItemId,
                instrumentationContext
            );
            return;
        case SxSReadingPaneInitializeMethod.LoadConversationReadingPane:
            initializeConversationReadingPaneInSxS(
                readingPaneStrategy,
                previewPaneSelectionSource,
                parentItemId,
                instrumentationContext
            );
            return;
        case SxSReadingPaneInitializeMethod.LoadItemReadingPane:
            initializeItemReadingPaneInSxS(readingPaneStrategy, instrumentationContext);
            return;
        default:
            return;
    }
});
